import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSpinrillaComponent } from './simple-icons-spinrilla.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSpinrillaComponent ],
    exports:      [ SimpleIconsSpinrillaComponent ],
    bootstrap:    []
})
export class SimpleIconsSpinrillaModule {}
